// answer: array of blocks. string = paragraph, string[] = bullet list.
const doctorFaqs = [
  {
    question: '¿Cómo accedo a la página web?',
    answer: [
      'Para acceder a la web, el equipo de coordinación de Diactive-1 te dará acceso a la plataforma. Recibirás un correo electrónico con las instrucciones para crear tu contraseña e ingresar a la web.',
    ],
  },
  {
    question: '¿Qué hago si no puedo iniciar sesión?',
    answer: [
      'Si no puedes iniciar sesión, te recomendamos restablecer tu contraseña desde la pantalla de inicio de www.diactive.es, presionando el botón "¿Has olvidado tu contraseña?".',
    ],
  },
  {
    question: '¿Qué hago si aún tengo problemas para iniciar sesión en la página web de Diactive-1?',
    answer: [
      'Si el problema persiste, por favor ponte en contacto con el equipo de coordinación de Diactive-1 escribiendo a: contacto@diactive.es',
    ],
  },
  {
    question: '¿Qué hago ahora que he entrado a la página web de Diactive-1?',
    answer: [
      'Una vez dentro de la página web, debes revisar todos los vídeos disponibles en el apartado "Tutoriales". Estos vídeos explican cómo utilizar la plataforma y sus principales funciones.',
    ],
  },
  {
    question: '¿Cómo puedo añadir un paciente?',
    answer: [
      'Para añadir un paciente, debes hacer clic en el apartado "Añadir paciente" y completar todos los campos solicitados. Es importante revisar que los datos estén correctamente escritos antes de guardar la información.',
    ],
  },
  {
    question: '¿Cómo sé si un paciente ha iniciado la intervención?',
    answer: [
      'En la pantalla principal podrás ver el apartado "Estado" del participante, representado mediante distintos colores.',
      [
        'Verde: el participante se encuentra en estado normal.',
        'Amarillo: requiere atención o revisión.',
        'Rojo: falta completar algún dato o acción importante.',
      ],
      'Para conocer el detalle del estado, coloca el cursor del ratón sobre el color correspondiente. La plataforma mostrará qué información falta o qué acción es necesaria.',
    ],
  },
  {
    question: '¿Qué evaluaciones debo realizar para la evaluación POST?',
    answer: [
      'Para la evaluación POST, deberás realizar al paciente las mismas pruebas que se realizaron en la evaluación PRE, siguiendo el protocolo del estudio. Además, deberás subir los archivos correspondientes, como los datos de glucosa y analítica, cuando corresponda. Por su parte, el paciente deberá responder los cuestionarios correspondientes a la evaluación POST.',
    ],
  },
  {
    question: '¿Cómo sé si un paciente ha completado todas la evaluación post?',
    answer: [
      'Al igual que en la evaluación PRE, deberás revisar el apartado "Estado" del participante. Para ver el detalle, coloca el cursor sobre el color correspondiente. La plataforma indicará qué información falta o si la evaluación está completa. Cuando el paciente haya completado el estudio en su totalidad, aparecerá en color gris con el mensaje "Estudio terminado".',
    ],
  },
  {
    question: '¿Qué hago si se ha introducido un dato erróneo?',
    answer: [
      'Si se ha introducido un dato erróneo, ponte en contacto con el equipo de coordinación de Diactive-1 escribiendo a: contacto@diactive.es. También puedes utilizar los números de teléfono que se hayan facilitado en correos anteriores. El equipo revisará el caso y te ayudará a corregir el problema lo antes posible.',
    ],
  },
  {
    question: '¿Qué debo hacer si un paciente no entrena durante varios días?',
    answer: [
      'El equipo de coordinación de Diactive-1 realizará seguimiento de la actividad de los participantes. Si un paciente no realiza los entrenamientos correspondientes durante varios días, el equipo de coordinación podrá ponerse en contacto contigo para que puedas hablar con el paciente o su familia y favorecer que retome los entrenamientos.',
    ],
  },
  {
    question: '¿Qué debo hacer si un paciente se enferma durante la intervención?',
    answer: [
      'Si un paciente se enferma durante la intervención, será necesario informar al equipo de coordinación de Diactive-1 escribiendo a: contacto@diactive.es. También puedes utilizar los números de teléfono facilitados previamente. Según la gravedad y duración de la situación, el equipo valorará cómo proceder.',
    ],
  },
  {
    question: '¿Qué significa que se hayan reseteado los días de un participante?',
    answer: [
      'Si se han reseteado los días de un participante, significa que el periodo original de intervención ha sido modificado y se ha establecido una nueva fecha de finalización. Esto puede ocurrir, por ejemplo, si el participante ha tenido algún problema que le impidió realizar la intervención con normalidad. En estos casos, será necesario revisar nuevamente la fecha prevista para la evaluación POST.',
    ],
  },
  {
    question: '¿Qué hago si el paciente no recibe el correo de acceso?',
    answer: [
      'Si el paciente no ha recibido el correo de acceso, primero se recomienda revisar que la dirección de correo esté correctamente escrita y pedir al paciente o familia que revise la carpeta de spam o correo no deseado. Si el correo sigue sin aparecer, será necesario contactar con el equipo de coordinación de Diactive-1 escribiendo a: contacto@diactive.es',
    ],
  },
  {
    question: '¿Puedo reenviar el correo de bienvenida?',
    answer: [
      'No. El reenvío del correo de bienvenida solo puede realizarlo el equipo de coordinación de Diactive-1. Si necesitas que se reenvíe este correo a un paciente, ponte en contacto con el equipo de coordinación escribiendo a: contacto@diactive.es. También puedes utilizar los números de teléfono facilitados previamente.',
    ],
  },
  {
    question: '¿Qué hago si la plataforma no me deja guardar una evaluación?',
    answer: [
      'Si tienes un problema para guardar la información, te recomendamos anotar los datos de forma manual para poder introducirlos posteriormente en la web. Si el problema persiste, ponte en contacto con el equipo de coordinación de Diactive-1 escribiendo a: contacto@diactive.es. También puedes utilizar los números de teléfono facilitados previamente.',
    ],
  },
  {
    question: '¿Qué información debo enviar al reportar un fallo técnico?',
    answer: [
      'Al reportar un fallo técnico, es recomendable enviar la mayor cantidad de información posible para que el equipo pueda identificar el problema. Se recomienda incluir:',
      [
        'Una captura de pantalla o vídeo del error.',
        'Una breve descripción de lo ocurrido.',
        'El nombre del paciente, si corresponde.',
        'El apartado de la web o app donde ocurrió el problema.',
        'El dispositivo o navegador utilizado, si es posible.',
      ],
      'Puedes enviar esta información al equipo de coordinación de Diactive-1 escribiendo a: contacto@diactive.es',
    ],
  },
  {
    question: '¿A quién debo contactar ante una incidencia?',
    answer: [
      'Ante cualquier incidencia, debes contactar con el equipo de coordinación de Diactive-1 escribiendo a: contacto@diactive.es. También puedes utilizar los números de teléfono que se hayan facilitado en correos anteriores.',
    ],
  },
];

export default doctorFaqs;
